import React from 'react';
import { Spinner } from '../../ui/Spinner';

/**
 * Generic "info" tab body — used by about / delivery / cancellation.
 * Renders a titled card with prose content or a fallback message.
 */
export function StoreInfoTab({ title, content, imageUrl, emptyMessage = 'אין מידע נוסף.' }) {
    return (
        <section className="max-w-2xl mx-auto surface-card p-8 mt-6 animate-fade-in">
            <h2 className="heading-lg mb-4">{title}</h2>
            {imageUrl && (
                <img
                    src={imageUrl}
                    alt={title}
                    className="mx-auto rounded-xl mb-6 max-w-full max-h-[28rem] object-contain"
                />
            )}
            <p className="text-ink-muted text-base sm:text-lg leading-relaxed whitespace-pre-line">
                {content && content.trim() ? content : emptyMessage}
            </p>
        </section>
    );
}

/**
 * FAQ tab — list of question/answer pairs.
 */
export function StoreFaqTab({ faqs, loading, error }) {
    return (
        <section className="max-w-2xl mx-auto surface-card p-8 mt-6 animate-fade-in">
            <h2 className="heading-lg mb-6">שאלות נפוצות</h2>
            {loading && (
                <div className="text-center py-8">
                    <Spinner size="lg" />
                </div>
            )}
            {error && (
                <div className="bg-danger-50 border border-danger-100 rounded-xl p-4 text-center">
                    <p className="text-danger-700">שגיאה בטעינת שאלות נפוצות</p>
                </div>
            )}
            {!loading && !error && faqs && faqs.length > 0 && (
                <div className="space-y-4">
                    {faqs.map((item, index) => (
                        <div key={item.faq_id || index} className="border-b border-line-subtle last:border-b-0 pb-4 last:pb-0">
                            <h3 className="text-lg font-bold text-ink mb-2">{item.question}</h3>
                            <p className="text-ink-muted leading-relaxed whitespace-pre-line">{item.answer}</p>
                        </div>
                    ))}
                </div>
            )}
            {!loading && !error && (!faqs || faqs.length === 0) && (
                <p className="text-ink-muted text-center py-4">אין שאלות נפוצות זמינות כרגע.</p>
            )}
        </section>
    );
}
